name = "playground"

[libraries]
vga = {git = "https://gitlab.com/spade-lang/lib/vga_spade", branch = "main"}
fixed = {git = "https://gitlab.com/spade-lang/lib/fixed", branch = "main"}
